<template>
  <div class="course-events-list">
    <table v-if="!emptyResults" :class="[withCourses ? 'dates-table--smaller' : '', 'dates-table']">
      <tbody>
        <CourseEvent v-for="(event, index) in allEvents" v-show="showRow(index)" :key="event.id" v-bind="event" />
      </tbody>
      <tfoot>
        <tr>
          <td colspan="8" style="text-align:center;padding-top: 20px;">
            <button v-show="!showAll" class="btn btn-outline-primary" @click.prevent="showAll = true">
              {{ $t('load_all') }}
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
    <div v-else-if="beforeInitialFetch">
      {{ $t("loading") }}
    </div>
    <div v-else>
      <p>
        <span v-html="$t('no_events_found')" />
        <br />
        <span v-html="$t('call_us_to_inhouse')" />
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CourseEvent from "./CourseEvent";

export default {
  name: "CourseEventsList",

  components: {
    CourseEvent
  },

  data() {
    return {
      showAll: false,
    }
  },
  computed: {
    ...mapGetters(["allEvents", "withCourses"]),
    ...mapState(["beforeInitialFetch"]),
    emptyResults() {
      return this.allEvents.length === 0;
    }
  },

  methods: {
    showRow(index) {
      if (index < 6) {
        return true;
      }

      return this.showAll;
    }
  }
};
</script>

<i18n>
{
  "cs": {
    "call_us_to_inhouse": "Pro objednávku inhouse školení nás prosím kontaktujte <strong>+420 222 553 101</strong>.",
    "load_all": "Načíst vše",
    "loading": "Načítám…",
    "no_events_found": "Tento kurz je možné <strong>objednat inhouse</strong>!"
  },
  "en": {
    "call_us_to_inhouse": "To order in house training, please contact us <strong>+420 222 553 101</strong>.",
    "load_all": "Show all",
    "loading": "Loading…",
    "no_events_found": "<strong>This course can be <strong>ordered inhouse</strong>!"
  },
   "sk": {
    "call_us_to_inhouse": "Ak si chcete objednať interné školenie, kontaktujte nás <strong> +420 222 553 101 </strong>.",
    "load_all": "Načíst všetky termíny",
    "loading": "Načítava…",
    "no_events_found": "<strong>Tento kurz je možné <strong> objednať interne </strong>!"
  } 
}
</i18n>
